import { Link } from 'react-router-dom';
import './Pages.css';

export default function NotFound() {
  return (
    <div className="page">
      <div className="container">
        <div className="nf">
          <div className="nf__code">404</div>
          <h1>Signal lost.</h1>
          <p>The page you're looking for doesn't exist, but the bridge is still here.</p>
          <Link to="/" className="btn btn--primary">
            Back to home
          </Link>
        </div>
      </div>
    </div>
  );
}
